export default __webpack_public_path__ + "background.2a0a2ee0.png";